module.exports = __webpack_public_path__ + "img/kymalogo-only-blue.0010db52.svg";